import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import API from '../api';
import {
  Box,
  Button,
  Markdown,
} from 'grommet';
import PageWrap from "../components/PageWrap";
import { shuffleArray } from '../utils/Misc';
import CategoriesComponent from '../components/Categories';
import YoutubeEmbed from './content/YoutubeEmbed';
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import FadeInInductee from './utility/FadeInInductee';
import Analytics from '../utils/Analytics';
import _ from 'lodash';
import { CenterModal, ModalTitle, ModalCloseTarget } from 'react-spring-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import InducteeModal from './InducteeModal';
import InducteeSlider from './InducteeSlider'; // adjust path as needed

function Arrow(props) {
  const disabled = props.disabled ? " arrow--disabled" : ""
  return (
    <svg
      onClick={props.onClick}
      className={`arrow ${
        props.left ? "arrow--left" : "arrow--right"
      } ${disabled}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {props.left && (
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
      )}
      {!props.left && (
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      )}
    </svg>
  )
}

const ComponentHallOfFame = ({t, i18n}) => {
  //const { match, i18n } = this.props;
  const [categories, setCategories] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [sliderLoaded, setSliderLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0)
  const [popup, setPopup] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [category, setCategory] = useState(false);
  const [inductee, setInductee] = useState(false);

  const [sliderRef] = useKeenSlider({
    slides: {
      perView: 3.5,
      spacing: 15,
    },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      console.log("created slider")
      setSliderLoaded(true)
    },
  })


  useEffect(() => {
    API.getCategories(i18n).then( (res) => {
      var categories = res.items
      // Move prtoduct references inline
      categories.forEach( (category) => {
        var products = []
        if (category.fields.hasOwnProperty('products')) {
          category.fields.products.forEach( (product) => { // Loop over products in cateogry
            var product_id = product.sys.id
            res.includes.Entry.forEach( (include) => { // Loop over all includes.Entry and find product
              if (include.sys.id === product_id){
                // Add to products array
                products.push(include.fields)
              }
            })
          })
        }
        //category.products = shuffleArray(products)
      })

      setCategories(categories);
      setLoaded(true);

    })
    .catch(console.error)
  }, []);

  const openPopup = (category, inductee) => {
    Analytics.TrackPageView(inductee.fields.product.fields.name, "/inductee/" + _.kebabCase(inductee.fields.product.fields.name));
    setCategory(category);
    setInductee(inductee);
    //setPopup(item);
    setPopupOpen(true);
  }

  const closePopup = (item) => {
    setPopupOpen(false);
    setTimeout(() => { setPopup(item)}, 500)
  }

  const renderInducteeImage = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('image')
    ){
      return (
        <img
          className="inducteeImage"
          src={winner.fields.product.fields.image.fields.file.url}
        />
      )
    } else {
      return (
        <p>No inductee image</p>
      )
    }
  }

  const renderInducteeName = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('name')
    ){
      return (
        <h3>{winner.fields.product.fields.name}</h3>
      )
    } else {
      return null;
    }
  }

  const renderInducteeSpecs = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('specs')
    ){
      return (
        <Box
          className="specs"
          direction="row"
          justify="stretch"
        >
          { winner.fields.product.fields.specs.map( (spec, index) => {
            return (
              <Box className="spec" flex="grow" key={index}>
                <h4 className="specTitle">{spec.fields.title}</h4>
                <div className="specValue">{spec.fields.value}</div>
              </Box>
            )
          })}
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeShortDescription = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('shortDescription')
    ){
      return (
        <p className="shortDescription">{winner.fields.product.fields.shortDescription}</p>
      )
    } else {
      return null
    }
  }

  const renderInducteeLongDescription = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('longDescription')
    ){
      return (
        <Box className="longDescription">
          <Markdown
            components={{
              "p": {
                "component": "Paragraph",
                "props": {"size": "medium"}
              }
            }}
          >{winner.fields.product.fields.longDescription }</Markdown>
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeVideo = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('videoId')
      && winner.fields.product.fields.videoId
    ){
      return (
        <Box className="video">
          <YoutubeEmbed embedId={winner.fields.product.fields.videoId} />
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeCTA = (winner) => {
    if (
      winner.fields.hasOwnProperty('product')
      && winner.fields.product
      && winner.fields.product.fields.hasOwnProperty('cta01')
      && winner.fields.product.fields.cta01
      && winner.fields.product.fields.hasOwnProperty('ctaLink')
      && winner.fields.product.fields.ctaLink
    ){
      return (
        <Box className="ctaWrapper" pad="medium" justify="center" align="center">
          <Button
            primary
            href={winner.fields.product.fields.ctaLink}
            label={winner.fields.product.fields.cta01}
          />
        </Box>
      )
    } else {
      return null
    }
  }

  const renderPopup = () => {
    if (inductee && category){
      return (
        <InducteeModal
          t={t}
          inductee={inductee?.fields?.product}
          year={inductee?.fields?.year}
          category={category}
        />
      )
    }
  }

  // render Category Image for the category header (not inductee)
  const renderHeaderCategoryImage = (category) => {
    if (
      category.hasOwnProperty('fields')
      && category.fields.hasOwnProperty('image')
    ){
      return (
        <img
          className="museum__category__header__image"
          alt={category.fields.name}
          src={category.fields.image.fields.file.url}
        />
      )
    }
  }

  /**
   * Render Category Subheader for the category header (not inductee). This is the short description field in Contentful
   */
  const renderHeaderCategorySubheader = (category) => {
    if (
      category.hasOwnProperty('fields')
      && category.fields.hasOwnProperty('shortDescription')
    ){
      return (
        <div className="museum__category__header__subheader bigText">
          <p>{category.fields.shortDescription}</p>
        </div>
      )
    }
  }

  // render Category Image
  const renderCategoryImage = (category) => {
    if (
      category.hasOwnProperty('fields')
      && category.fields.hasOwnProperty('image')
    ){
      return (
        <img
          key={1}
          className="museum__category__winner__category-image"
          alt={category.fields.name}
          src={category.fields.image.fields.file.url}
        />
      )
    }
  }

  // Render Year Text
  const renderYearText = (winner) => {
    return (
      <div key={2} className="museum__category__winner__text">
        {/*
        <div className="museum__category__winner__text__year">
         {winner.fields.year}
        </div>
        */}
        <div className="museum__category__winner__text__winner">
         WINNER
        </div>
      </div>
    )
  }

  // Render Winners (one per year)
  const renderWinners = (category) => {
    return category.fields.inductees.map((winner) => {
      return (   
        <div 
          key={winner.fields.year} 
          className="keen-slider__slide museum__category__winner"
          style={{}}
        >
           <FadeInInductee
              className="inducteeSlide"
              animate={false}
              delay={0}
              calcBasis={() => 1}
              extra={[
                renderCategoryImage(category, true),
                renderYearText(winner)
              ]}
              onClick={() => {openPopup(category, winner)}}
           >
              {renderInducteeImage(winner)}
              <div className="inducteeContent">
                <Box className="textWrapper">
                  {renderInducteeName(winner)}
                  {renderInducteeShortDescription(winner)}
                </Box>

                <Box className="buttonWrapper inducteeButtonContainer">
                  <Button
                    primary
                    label={t("Learn more")}
                    fill="horizontal"
                    focusIndicator={false}
                    hoverIndicator={false}
                  />
                </Box>
              </div>
          </FadeInInductee>
        </div>
      )
    })
    
  }

  // Render each category
  const renderCategories = () => {
    if (loaded === false){
      return null;
    } else {
      return categories.map( (category) => {

        return (
          <Box className="museum__category" key={category.sys.id}>
            <div className="museum__category__header">
              <div className="museum__category__header__divider"></div>
                {renderHeaderCategoryImage(category)}
              <div className="museum__category__header__divider"></div>
            </div>
            {renderHeaderCategorySubheader(category)}
            <div 
              ref={sliderRef} 
              className="keen-slider museum__category__winners"
            >
              {renderWinners(category)}
            </div>

            {sliderLoaded && sliderRef.current && (
            <div className="museum__category__arrows">
                <h2>Arrows</h2>
              <Arrow
                left
                onClick={(e) =>
                  e.stopPropagation() || sliderRef.current?.prev()
                }
                disabled={currentSlide === 0}
              />

              <Arrow
                onClick={(e) =>
                  e.stopPropagation() || sliderRef.current?.next()
                }
                disabled={
                  currentSlide ===
                  sliderRef.current.track.details.slides.length - 1
                }
              />
            </div>
          )}
          </Box>
        )
      });
    }
  }

  return (
      <Box id="page">
        <CenterModal
          isOpen={popupOpen}
          onDismiss={() => closePopup(false)}
          contentTransition={{
            from: { background: 'black', transform: 'translateY(-100%)' },
            enter: { background: 'black', transform: 'translateY(0)' },
            leave: { background: 'black', transform: 'translateY(-100%)' }
          }}
        >
          <ModalCloseTarget>
            <button className="modalClose"><FontAwesomeIcon icon={faTimesCircle} /></button>
          </ModalCloseTarget>
          {renderPopup()}
        </CenterModal>

        <PageWrap content={categories}>
          <div className="museum">
            {loaded && categories.map((cat) => (
              <InducteeSlider 
                key={cat.fields.name} 
                category={cat} 
                t={t}
                onInducteeClick={openPopup} // Pass the function to open the modal
              />
            ))}
          </div>
        </PageWrap>

        {/**
        <ul>
          <li>
            <Link to={`${match.url}/rendering`}>
              <Trans>Rendering with React</Trans>
            </Link>
          </li>
          <li>
            <Link to={`${match.url}/components`}>Components</Link>
          </li>
          <li>
            <Link to={`${match.url}/props-v-state`}>Props v. State</Link>
          </li>
        </ul>


        <Route path={`${match.url}/:categoryId`} component={Category} />
        <Route
          exact
          path={match.url}
          render={() => <h3>Please select a category.</h3>}
        />

        **/}
      </Box>
    );
}

export default withTranslation("translations")(ComponentHallOfFame);
